/**
 * Cart store/reducer
 */

import {
  SET_CART_TOTAL,
  SET_CURRENT_ORDER,
  SET_LINE_ITEMS,
  SET_PROMO_INPUT_VALUE,
  SET_CURRENT_PROMO_CODE,
  SET_SHOULD_SHOW_PROMO_INPUT,
  SET_IS_PROMO_APPLIED,
  SET_IS_OPEN,
  SET_SHOW_TOS,
  SET_PROMO_ERRORS,
  SET_CART_ERRORS,
} from './actions';
import { getCurrentOrder, getLineItems } from 'utils/cartHelpers';
import {
  CartStateType,
  ReducerActionType,
  CartTotalType,
  Order,
  Errors,
  LineItem,
} from 'utils/types';

export const initialState: CartStateType = {
  cartTotal: {
    productQuantity: 0,
    totalPrice: 0,
    subTotal: 0,
    currencyId: 'USD',
    currencyFormat: '$',
  },
  currentOrder: getCurrentOrder(),
  lineItems: getLineItems(),
  promoInputValue: '',
  currentPromoCode: '',
  shouldShowPromoInput: false,
  isPromoApplied: false,
  isOpen: false,
  showTOS: false,
  promoErrors: null,
  cartErrors: null,
};

export const reducer = (state: CartStateType, action: ReducerActionType) => {
  switch (action.type) {
    case SET_CART_TOTAL:
      return { ...state, cartTotal: action.payload as CartTotalType };
    case SET_CURRENT_ORDER:
      return { ...state, currentOrder: action.payload as Order };
    case SET_LINE_ITEMS:
      return { ...state, lineItems: action.payload as LineItem[] };
    case SET_PROMO_INPUT_VALUE:
      return { ...state, promoInputValue: action.payload as string };
    case SET_CURRENT_PROMO_CODE:
      return { ...state, currentPromoCode: action.payload as string };
    case SET_SHOULD_SHOW_PROMO_INPUT:
      return { ...state, shouldShowPromoInput: action.payload as boolean };
    case SET_IS_PROMO_APPLIED:
      return { ...state, isPromoApplied: action.payload as boolean };
    case SET_IS_OPEN:
      return { ...state, isOpen: action.payload as boolean };
    case SET_SHOW_TOS:
      return { ...state, showTOS: action.payload as boolean };
    case SET_PROMO_ERRORS:
      return { ...state, promoErrors: action.payload as Errors };
    case SET_CART_ERRORS:
      return { ...state, cartErrors: action.payload as Errors };
    default:
      return state;
  }
};
